import { ContentstackConfigService } from '@csp/csp-common-content-delivery-client';
import { CspError, Maybe } from '@csp/csp-common-model';

/**
 *  @description Checks if content is undefined or empty array and returns mocked content in that case
 *
 * @param {T} content The content that should be return in a happy case
 * @param {string} errorMessage Error message if there is no content
 * @param {T} mock Fallback mock that is used if no content and mocks are allowed
 * @param {T} [fallback] Optional fallback if neither content or mock should be used
 * @returns {T} Content OR Mock OR fallback (in that order)
 */
export const getOrDefault = <T>(content: Maybe<T>, errorMessage: string, mock: T, fallback?: T): T => {
  if (content === undefined || (Array.isArray(content) && !content.length)) {
    if (ContentstackConfigService.get().allowMockedContent) {
      console.debug(`${errorMessage}. Using mock instead`);
      return mock;
    } else if (fallback) {
      return fallback;
    } else {
      throw CspError.badState(errorMessage);
    }
  }

  return content;
};
